export default __webpack_public_path__ + "static/media/nexity.606ee8f7.png";